import { IncorporationCompanyRef } from './types';

export const canTrackCompany = (company?: IncorporationCompanyRef | null): boolean => Boolean(company?.id);
